import { render, staticRenderFns } from "./PresentationYoutube.vue?vue&type=template&id=be34e8e6&scoped=true&"
import script from "./PresentationYoutube.vue?vue&type=script&lang=js&"
export * from "./PresentationYoutube.vue?vue&type=script&lang=js&"
import style0 from "./PresentationYoutube.vue?vue&type=style&index=0&id=be34e8e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be34e8e6",
  null
  
)

export default component.exports